const replace = (target: string, searchValues: string[]) => {
  if (typeof target === 'string') {
    for (const searchValue of searchValues) {
      if (target.startsWith(searchValue)) {
        return target.replace(searchValue, '')
      }
    }
  }
  return target
}

export class CmsContentService {
  static getCoverImg(content: string) {
    const contentfulCoverImgPattern = '!\\[.*\\]\\((.*?)["\\)]'
    const databaseCoverImgPattern = '<img[\\s\\S]*?src="(.*?)"'
    const imgCoverRegex = new RegExp(`(${contentfulCoverImgPattern}|${databaseCoverImgPattern})`)
    const matchResult = content.match(imgCoverRegex)
    if (matchResult) {
      const imgLink = matchResult[2] || matchResult[3]
      return replace(imgLink, ['http:', 'https:'])
    }
    return ''
  }
  static getAbstract(content: string) {
    if (content) {
      const text = CmsContentService.getMainText(content)
      return text
        .replace(/\[(.*?)\]\(.*?\)/g, '$1')
        .replace(/(\*\*|\r|\n|__|---|#|<.*?>|!\[.*\]\(.*?\)!?)/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s\[(.*?)\]\(.*?\)/g, ' $1')
    }
    return content
  }

  static getMainText(content: string) {
    const contentfulTextPattern = '!\\[.*\\)([\\s\\S\\r\\n]*)'
    const databaseTextPattern = '<img.*\\/>([\\s\\S\\r\\n]*)'
    const textRegex = new RegExp(`(${contentfulTextPattern}|${databaseTextPattern})`)
    const matchResult = content.match(textRegex)
    if (matchResult) {
      const text = matchResult[2] || matchResult[3]
      return text.replace(/&nbsp;/g, ' ')
    }
    return content.replace(/&nbsp;/g, ' ')
  }

  static formatHTMLContent(htmlContent: string, withoutCover = true) {
    return withoutCover ? htmlContent.replace(/<img.*>.*/, '') : htmlContent
  }
  static getBlankAnchor(htmlContent: string) {
    return htmlContent.replace(/<a\b/gi, '<a target="_blank"')
  }
}
